import { render, staticRenderFns } from "./SearchCustom.vue?vue&type=template&id=10c6b156&scoped=true&"
import script from "./SearchCustom.vue?vue&type=script&lang=js&"
export * from "./SearchCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c6b156",
  null
  
)

export default component.exports